import styled from 'styled-components';

const AboutUsBody = styled.div`
  font-family: "Avenir", "Arial", sans-serif;
  text-align: justify;
  line-height: 18px;
`;

export default AboutUsBody;
